var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveicons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 3H5.4C4.077 3 3 4.077 3 5.4V18.6C3 19.923 4.077 21 5.4 21H18.6C19.923 21 21 19.923 21 18.6V5.4C21 4.077 19.923 3 18.6 3ZM14.3798 4.2V6.84H9.62112V4.2H14.3798ZM19.8 18.6C19.8 19.2615 19.2615 19.8 18.6 19.8H5.4C4.7385 19.8 4.2 19.2615 4.2 18.6V5.4C4.2 4.7385 4.7385 4.2 5.4 4.2H8.42016V6.84077C8.42016 7.50227 8.95866 8.04077 9.62016 8.04077H14.3789C15.0404 8.04077 15.5789 7.50227 15.5789 6.84077V4.2H18.599C19.2605 4.2 19.799 4.7385 19.799 5.4V18.6H19.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveicons);
export default __webpack_public_path__ + "static/media/saveicons.4d33080f0f7cdeaf747d4e52e1b07c39.svg";
export { ForwardRef as ReactComponent };